
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/changelog",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/changelog/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/changelog"])
      });
    }
  